/** 未登录 / 接口失败时的货架兜底数据 */
export const _goodsData = {
    plan_shelf: {
        goods: [
            {
                id: 21007,
                name: 'Basic',
                subscription_type: 'PLAN_ENTRY',
                period_type: 'MONTHLY',
                price_currency: '$',
                price: 1499,
                price_show: '$14.99',
                payment_types: [
                    'paypal_subs_h5',
                    'air_wallex_subs',
                    'creem_subs_h5',
                    'air_wallex_subs_h5',
                    'sunshine_pe_subs_h5',
                    'payer_max_subs_h5',
                ],
                current_subscription: false,
                can_upgrade: false,
                month_credit: 250,
                support_image_count: 1300,
                support_video_count: 80,
            },
            {
                id: 21021,
                name: 'Standard',
                subscription_type: 'PLAN_BASIC',
                period_type: 'MONTHLY',
                price_currency: '$',
                price: 2999,
                price_show: '$29.99',
                payment_types: ['creem_subs_h5'],
                current_subscription: false,
                can_upgrade: false,
                month_credit: 600,
                support_image_count: 3000,
                support_video_count: 180,
            },
            {
                id: 21022,
                name: 'Pro',
                subscription_type: 'PLAN_PRO',
                period_type: 'MONTHLY',
                price_currency: '$',
                price: 6999,
                price_show: '$69.99',
                payment_types: ['creem_subs_h5'],
                current_subscription: false,
                can_upgrade: false,
                month_credit: 1700,
                support_image_count: 7600,
                support_video_count: 460,
            },
            {
                id: 21023,
                name: 'Ultra',
                subscription_type: 'PLAN_ULTRA',
                period_type: 'MONTHLY',
                price_currency: '$',
                price: 19999,
                price_show: '$199.99',
                payment_types: ['creem_subs_h5'],
                current_subscription: false,
                can_upgrade: false,
                month_credit: 4600,
                support_image_count: 20000,
                support_video_count: 1220,
            },
        ],
    },
    annual_plan_shelf: {
        goods: [
            {
                id: 21107,
                name: 'Basic',
                subscription_type: 'PLAN_ENTRY',
                period_type: 'YEARLY',
                price_currency: '$',
                price: 14300,
                price_show: '$143.00',
                origin_price: 17988,
                origin_price_show: '$179.88',
                payment_types: [
                    'paypal_subs_h5',
                    'creem_subs_h5',
                    'air_wallex_subs_h5',
                    'sunshine_pe_subs_h5',
                    'payer_max_subs_h5',
                ],
                current_subscription: false,
                can_upgrade: false,
                month_credit: 250,
                support_image_count: 1300,
                support_video_count: 80,
            },
            {
                id: 21117,
                name: 'Standard',
                subscription_type: 'PLAN_BASIC',
                period_type: 'YEARLY',
                price_currency: '$',
                price: 26988,
                price_show: '$269.88',
                origin_price: 35988,
                origin_price_show: '$359.88',
                payment_types: ['creem_subs_h5'],
                current_subscription: false,
                can_upgrade: false,
                month_credit: 600,
                support_image_count: 3000,
                support_video_count: 180,
            },
            {
                id: 21118,
                name: 'Pro',
                subscription_type: 'PLAN_PRO',
                period_type: 'YEARLY',
                price_currency: '$',
                price: 58788,
                price_show: '$587.88',
                origin_price: 83988,
                origin_price_show: '$839.88',
                payment_types: ['creem_subs_h5'],
                current_subscription: false,
                can_upgrade: false,
                month_credit: 1700,
                support_image_count: 7600,
                support_video_count: 460,
            },
            {
                id: 21119,
                name: 'Ultra',
                subscription_type: 'PLAN_ULTRA',
                period_type: 'YEARLY',
                price_currency: '$',
                price: 155988,
                price_show: '$1559.88',
                // 月费 Ultra $199.99 × 12
                origin_price: 239988,
                origin_price_show: '$2399.88',
                payment_types: ['creem_subs_h5'],
                current_subscription: false,
                can_upgrade: false,
                month_credit: 4600,
                support_image_count: 20000,
                support_video_count: 1220,
            },
        ],
    },
    credits_shelf: {
        goods: [
            {
                id: 22018,
                name: '1250 Credits',
                price: 4999,
                price_show: '$49.99',
                credits: 1250,
                payment_types: ['creem_h5'],
            },
            {
                id: 22019,
                name: '2800 Credits',
                price: 9999,
                price_show: '$99.99',
                credits: 2800,
                payment_types: ['creem_h5'],
            },
            {
                id: 22020,
                name: '6250 Credits',
                price: 19999,
                price_show: '$199.99',
                credits: 6250,
                payment_types: ['creem_h5'],
            },
            {
                id: 22021,
                name: '18000 Credits',
                price: 49999,
                price_show: '$499.99',
                credits: 18000,
                payment_types: ['creem_h5'],
            },
        ],
    },
    chat_annual_plan_shelf: {
        goods: [
            {
                id: 23101,
                name: 'Basic',
                subscription_type: 'CHAT_PLAN',
                period_type: 'YEARLY',
                price: 11994,
                price_show: '$119.94',
                origin_price: 23988,
                origin_price_show: '$239.88',
                payment_types: ['creem_subs_h5'],
            },
        ],
    },
    chat_plan_shelf: {
        goods: [
            {
                id: 23001,
                name: 'Basic',
                subscription_type: 'CHAT_PLAN',
                period_type: 'MONTHLY',
                price: 1999,
                price_show: '$19.99',
                origin_price: 2499,
                origin_price_show: '$24.99',
                payment_types: ['creem_subs_h5'],
            },
        ],
    },
    seats_shelf: {
        goods: [],
    },
    default_subscription_payment_type: 'creem_subs_h5',
    default_one_time_payment_type: 'creem_h5',
}
